import { Controller } from '@hotwired/stimulus'
import { HelloAlert } from '../components/HelloAlert'

export default class extends Controller {
  static override targets = ['name', 'output']

  declare readonly nameTarget: HTMLInputElement
  declare readonly outputTarget: HTMLElement
  declare readonly hasNameTarget: boolean
  declare readonly hasOutputTarget: boolean

  override connect(): void {
    console.log('Hello controller connected!')
  }

  showAlert(): void {
    alert('Hello World! This is a simple JavaScript alert.')
  }

  showScopedAlert(): void {
    this.#createAlert('Scoped Alert', this.name)
  }

  updateOutput(valueOrEvent: string | Event): void {
    if (typeof valueOrEvent === 'string') {
      this.nameTarget.value = valueOrEvent
    }
    this.outputTarget.textContent = this.nameTarget.value
  }

  get name(): string {
    return this.nameTarget.value
  }

  #createAlert(title: string, message: string): void {
    this.#removeScopedAlerts()

    const alertComponent = new HelloAlert()
    alertComponent.setAttribute('title', title)
    alertComponent.setAttribute('message', message)
    alertComponent.addEventListener('close', () => alertComponent.setAttribute('open', 'false'))
    // @ts-expect-error irrelevant
    alertComponent.addEventListener('input', (event: CustomEvent) => {
      this.updateOutput(event.detail.value)
    })

    document.body.appendChild(alertComponent)
  }

  #removeScopedAlerts(): void {
    const existing = document.querySelectorAll('hello-alert')
    existing.forEach((alert) => alert.remove())
  }
}
